import { phonePattern } from '@/components/SmsCodeFormItem'
import i18n from '@/utils/i18n';

export const sdkList = [{ label: `${i18n.t('user-center.login.other-login-list.sdk-1')}`, value: 'ewan' }, { label: `${i18n.t('user-center.login.other-login-list.sdk-2')}`, value: 'miao' }];

export const typeList = [{ label: `${i18n.t('user-center.login.other-login-list.type-1')}`, value: 1 }, { label: `${i18n.t('user-center.login.other-login-list.type-2')}`, value: 2 }, { label: `${i18n.t('user-center.login.other-login-list.type-3')}`, value: 3 }];

export const rules: any = {
  sdk: [{ required: true }, { type: 'string' }],
  type: [{ required: true }, { type: 'number' }],
  account: [{ required: true }, { type: 'string' }],
  password: [{ required: true }, { type: 'string' }],
  phone: [{ required: true }, { type: 'string' }, { pattern: phonePattern, message: `${i18n.t('user-center.login.rule-phone')}`, validateTrigger: 'onSubmit' }],
  agree: [{ validator: (rule, value) => value ? Promise.resolve() : Promise.reject(`${i18n.t('user-center.login.rule-agree')}`) }],
  openId: [{ required: true }, { type: 'string' }],
  userId: [{ required: true }, { type: 'string' }],
}
